import * as _ from "lodash";
import { UsersRepo } from "@services/users.repo";
import { UserItem } from "./UserItem";
import { AuthService as authService } from "@common/auth.service";
import { extractErrorMessage } from "@common/utils/errorUtils";

class userListController implements angular.IOnInit {
  public users: UserItem[] = [];
  public clients: UserItem[] = [];
  public filteredUsers: Array<UserItem> = [];
  public filteredClients: Array<UserItem> = [];
  public searchText: string;
  public statusFilter: string = "";
  public statusFilterClients: string = "";
  public statusOptions: Array<string> = [
    "All",
    "Active",
    "Disabled",
    "Awaiting Confirmation",
    "Unknown",
  ];
  public loadingUsers: Set<string> = new Set(); // Track which users are being processed

  /** @ngInject */
  constructor(
    private usersRepo: UsersRepo,
    private $state: angular.ui.IStateService,
    private notifyjs: any,
    private authService: authService
  ) {}

  $onInit() {
    this.populateUserData();
  }

  populateUserData() {
    this.users = [];
    this.usersRepo
      .getUsers()
      .then((users) => {
        this.users = users.filter(
          (u) => !u.isClient && u.name !== null && u.email !== null
        );
        this.clients = users.filter(
          (u) => u.isClient && u.name !== null && u.email !== null
        );
        this.filteredUsers = this.sortUsersByStatus([...this.users]);
        this.filteredClients = this.sortUsersByStatus([...this.clients]);
      })
      .catch((err) => this.notifyjs(`Failed to retrieve users: ${extractErrorMessage(err)}`));
  }

  viewUserDetails(user: UserItem) {
    this.$state.go("root.users.details", { id: user.id });
  }

  createNewUser() {
    this.$state.go("root.users.create");
  }

  getUserStatus(user) {
    if (!user.isActive) return "Disabled";
    else {
      switch (user.status) {
        case "CONFIRMED": {
          return "Active";
        }
        case "FORCE_CHANGE_PASSWORD": {
          return "Awaiting Confirmation";
        }
        default: {
          return "Unknown";
        }
      }
    }
  }

  resendInvite(event: angular.IAngularEvent, user: UserItem) {
    event.stopPropagation();

    this.usersRepo
      .resendInvite(user.id)
      .then(() => this.notifyjs("Invitation has been resent", "info"));
  }

  sortUsersByStatus(userItems: Array<UserItem>) {
    const statusOrder = (s: string | null | undefined) =>
      s === "CONFIRMED" ? 0 : s === "FORCE_CHANGE_PASSWORD" ? 1 : 2;

    return [...userItems].sort((a, b) => {
      const nameA = a.name || "";
      const nameB = b.name || "";
      const aOrder = statusOrder(a.status);
      const bOrder = statusOrder(b.status);

      if (aOrder !== bOrder) return aOrder - bOrder;
      return nameA.localeCompare(nameB);
    });
  }

  filterColumn(filter: string) {
    try {
      if (
        this.statusFilter === "All" ||
        this.statusFilter === "" ||
        this.statusFilter === null ||
        this.statusFilter === undefined
      ) {
        this.filteredUsers = this.sortUsersByStatus([...this.users]);
        return;
      }

      this.filteredUsers = this.sortUsersByStatus([
        ...this.users.filter((user) => this.getUserStatus(user) === filter),
      ]);
    } catch (error) {
      this.filteredUsers = this.sortUsersByStatus([...this.users]);
    }
  }

  filterClientsColumn(filter: string) {
    try {
      if (
        this.statusFilterClients === "All" ||
        this.statusFilterClients === "" ||
        this.statusFilterClients === null ||
        this.statusFilterClients === undefined
      ) {
        this.filteredClients = this.sortUsersByStatus([...this.clients]);
        return;
      }

      this.filteredClients = this.sortUsersByStatus([
        ...this.clients.filter(
          (client) => this.getUserStatus(client) === filter
        ),
      ]);
    } catch (error) {
      this.filteredClients = this.sortUsersByStatus([...this.clients]);
    }
  }

  isLoadingUser(user: UserItem): boolean {
    return this.loadingUsers.has(user.id.toString());
  }
}

export const userList: angular.IComponentOptions = {
  template: require("./userList.html"),
  controller: userListController,
};



// WEBPACK FOOTER //
// ./src/app/users/userList.ts